import { useQuery } from '@tanstack/react-query'

import { meApi } from '@/api/endpoints'
import { queryKeys } from '@/api/queryKeys'

/**
 * Il profilo azienda dell'utente autenticato. Serve anche a un uso che non è
 * di visualizzazione: `role` decide se il modulo Aziende compare in
 * navigazione. Il backend resta comunque l'autorità — questo è solo il
 * segnale per non mostrare in giro una porta che il server chiuderebbe.
 */
export function useMe() {
  return useQuery({
    queryKey: queryKeys.me,
    queryFn: () => meApi.get(),
    staleTime: 5 * 60_000,
  })
}
